import type { OAuthMaterial } from "./OAuthFlowExecutor.types";

export type CredentialMaterialRef = Readonly<{
  source: "local" | "control-plane";
  id: string;
}>;

export type MaterialBundle = OAuthMaterial;

export type CallerContext = Readonly<{
  workspaceId: string;
  caller:
    | Readonly<{ kind: "workflow-node"; workflowId: string; nodeId: string }>
    | Readonly<{ kind: "concierge"; chatId: string }>
    | Readonly<{ kind: "research-agent"; chatId: string }>
    | Readonly<{ kind: "manual"; userId: string }>;
  reason?: string;
}>;

export interface CredentialMaterialProvider {
  getMaterial(ref: CredentialMaterialRef, context: CallerContext): Promise<MaterialBundle>;
  setMaterial(ref: CredentialMaterialRef, material: MaterialBundle): Promise<void>;
}

export class IllegalMaterialSourceError extends Error {
  constructor(
    public readonly source: CredentialMaterialRef["source"],
    public readonly providerName: string,
  ) {
    super(`Provider "${providerName}" cannot handle material source "${source}".`);
    this.name = "IllegalMaterialSourceError";
  }
}
